import React from "react";
import { ArrowLeft, Palette } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import BrandStudioShell from "@/components/brandStudio/BrandStudioShell";
import { getBrandStudioEntry } from "@/lib/brandStudioCatalog.mjs";
import ThankYouCardWorkspaceV1 from "../../components/brandStudio/ThankYouCardWorkspaceV1";
import PremiumOrderTagWorkspaceV1 from "../../components/brandStudio/PremiumOrderTagWorkspaceV1";
import TagMaterialEditorV1 from "../../components/brandStudio/TagMaterialEditorV1";

export default function MOBrandStudioWorkspace() {
  const nav = useNavigate();
  const { workspaceSlug } = useParams();
  const entry = getBrandStudioEntry(workspaceSlug);

  if (workspaceSlug === "tag") return <TagMaterialEditorV1 />;
  if (workspaceSlug === "thank-you") return <ThankYouCardWorkspaceV1 />;
  if (workspaceSlug === "premium-order-tag") return <PremiumOrderTagWorkspaceV1 />;

  return (
    <BrandStudioShell title={entry?.title || "Brand Studio"}>
      <div className="pb-16 max-w-4xl overflow-x-clip"
           data-testid="mo-brand-studio-workspace">
        <button type="button"
                onClick={() => nav("/brand-studio")}
                className="mb-4 h-9 px-3 rounded-xl text-[12.5px] inline-flex items-center gap-1 transition-colors hover:bg-[#F7F1E7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C7A574]/40 focus-visible:ring-offset-2"
                style={{
                  background: "#FFFDF8",
                  color: "#4A3728",
                  boxShadow: "inset 0 0 0 1px #D8C7A7",
                }}
                data-testid="mo-brand-studio-workspace-back">
          <ArrowLeft size={13} /> Brand Studio
        </button>

        {entry ? (
          <>
            <section className="rounded-2xl bg-white p-5 md:p-7"
                     style={{ boxShadow: "inset 0 0 0 1px #EFE4D0" }}
                     data-testid={`mo-brand-studio-workspace-${entry.slug}`}>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl grid place-items-center shrink-0"
                     style={{ background: "#F5EBD8", color: "#8B6F4B" }}>
                  <Palette size={17} strokeWidth={1.6} />
                </div>
                <div className="min-w-0">
                  <div className="text-[10.5px] tracking-[0.18em] uppercase"
                       style={{ color: "#8B6F4B" }}>
                    {entry.categoryType === "workspace" ? "Твоя мастерская" : "Что хочешь создать?"}
                  </div>
                  <h1 className="mt-1 text-[26px] md:text-[32px] leading-tight"
                      style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2A1D14" }}>
                    {entry.title}
                  </h1>
                  <p className="mt-2 max-w-2xl text-[13.5px] md:text-[14px] leading-relaxed"
                     style={{ color: "#5B4326" }}>
                    {entry.shortDescription}
                  </p>
                </div>
              </div>
            </section>

            <section className="mt-4 rounded-2xl p-5 md:p-6 min-w-0 overflow-hidden"
                     style={{
                       background: "#FBF5EA",
                       boxShadow: "inset 0 0 0 1px #EFE4D0",
                     }}
                     data-testid="mo-brand-studio-foundation-state">
              <div className="text-[17px]"
                   style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2A1D14" }}>
                {entry.emptyTitle || "Профессиональные варианты"}
              </div>
              <p className="mt-1.5 max-w-2xl text-[12.5px] md:text-[13px] leading-relaxed"
                 style={{ color: "#8B6F4B" }}>
                {entry.emptyDescription ||
                  "Здесь будут собраны профессиональные варианты Anokina Studio, которые используют данные твоего Brand Profile."}
              </p>
            </section>
          </>
        ) : (
          <section className="rounded-2xl bg-white p-5 md:p-7"
                   style={{ boxShadow: "inset 0 0 0 1px #EFE4D0" }}
                   data-testid="mo-brand-studio-workspace-unknown">
            <h1 className="text-[26px] md:text-[32px] leading-tight"
                style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2A1D14" }}>
              Раздел Brand Studio не найден
            </h1>
            <p className="mt-2 text-[13.5px] leading-relaxed" style={{ color: "#5B4326" }}>
              Вернись в Brand Studio и выбери нужную категорию в мастерской.
            </p>
          </section>
        )}
      </div>
    </BrandStudioShell>
  );
}

